import { extractTextFromTipTap } from "./schemas/CharacterSchema.js";
import { AI_VISIBILITY } from "./enums.js";

/** Same list as Draft scenes entity visualization — filters trivial tokens. */
export const STORY_BIBLE_COMMON_WORDS = [
  "i",
  "me",
  "my",
  "myself",
  "we",
  "our",
  "ours",
  "ourselves",
  "you",
  "your",
  "yours",
  "yourself",
  "yourselves",
  "he",
  "him",
  "his",
  "himself",
  "she",
  "her",
  "hers",
  "herself",
  "it",
  "its",
  "itself",
  "they",
  "them",
  "their",
  "theirs",
  "themselves",
  "what",
  "which",
  "who",
  "whom",
  "this",
  "that",
  "these",
  "those",
  "am",
  "is",
  "are",
  "was",
  "were",
  "be",
  "been",
  "being",
  "have",
  "has",
  "had",
  "having",
  "do",
  "does",
  "did",
  "doing",
  "a",
  "an",
  "the",
  "and",
  "but",
  "if",
  "or",
  "because",
  "as",
  "until",
  "while",
  "of",
  "at",
  "by",
  "for",
  "with",
  "about",
  "against",
  "between",
  "into",
  "through",
  "during",
  "before",
  "after",
  "above",
  "below",
  "to",
  "from",
  "up",
  "down",
  "in",
  "out",
  "on",
  "off",
  "over",
  "under",
  "again",
  "further",
  "then",
  "once",
  "here",
  "there",
  "when",
  "where",
  "why",
  "how",
  "all",
  "any",
  "both",
  "each",
  "feedback",
  "few",
  "more",
  "most",
  "other",
  "some",
  "such",
  "no",
  "nor",
  "not",
  "only",
  "own",
  "same",
  "so",
  "than",
  "too",
  "very",
  "can",
  "will",
  "just",
  "don",
  "should",
  "now",
];

export function isNotCommonWord(word) {
  const test = word.trim().toLowerCase();
  return !STORY_BIBLE_COMMON_WORDS.includes(test);
}

/**
 * Harvests plain-text name tokens from characters, worldbuilding, and optional project documents (same rules as Draft entity underlines).
 * @param {{ charactersEntities?: any[]; worldbuildingEntries?: any[]; documents?: { title?: string }[] }} param0
 * @returns {string[]}
 */
export function harvestStoryBibleEntityNamesFromEntities({ charactersEntities = [], worldbuildingEntries = [], documents: documentsList = [] }) {
  const characterNames = (charactersEntities || [])
    .filter((character) => character.aiVisibility !== AI_VISIBILITY.HIDDEN)
    .map((character) => {
      const name = extractTextFromTipTap(character.name);
      const otherNames = extractTextFromTipTap(character.otherNames);
      return { name, otherNames };
    })
    .filter((character) => character.name)
    .reduce((acc, character) => {
      const name = character.name;
      acc.add(name);
      const split = name.split(" ");
      split.forEach((n) => acc.add(n));
      const otherNames = character.otherNames
        .split(/[,;]/)
        .map((n) => n.trim())
        .filter(Boolean);
      otherNames.forEach((n) => acc.add(n));
      return acc;
    }, new Set());

  const worldbuildingNames = (worldbuildingEntries || [])
    .filter((entry) => entry.aiVisibility !== AI_VISIBILITY.HIDDEN)
    .map((entry) => {
      const name = extractTextFromTipTap(entry.name);
      const otherNames = extractTextFromTipTap(entry.otherNames);
      return { name, otherNames };
    })
    .filter((entry) => entry.name)
    .reduce((acc, entry) => {
      const name = entry.name;
      acc.add(name);
      const otherNames = entry.otherNames
        .split(/[,;]/)
        .map((n) => n.trim())
        .filter(Boolean);
      otherNames.forEach((n) => acc.add(n));
      return acc;
    }, new Set());

  const documentNameTokens = (documentsList || []).reduce((acc, doc) => {
    const title = (doc.title || "").trim();
    if (!title) return acc;
    acc.add(title);
    title.split(/\s+/).forEach((w) => acc.add(w));
    return acc;
  }, new Set());

  const completeSet = new Set([...characterNames, ...worldbuildingNames, ...documentNameTokens]);
  return Array.from(completeSet)
    .map((name) => name.trim())
    .filter(Boolean)
    .filter(isNotCommonWord);
}
